/* eslint-disable implicit-arrow-linebreak */
export const COCKPIT_COOKIE_NAME = 'CockpitLogged'

export const getCookie = (name = '', cookies = '') => {
  const v = cookies.match(`(^|;) ?${name}=([^;]*)(;|$)`)
  return v ? v[2] : null
}

// eslint-disable-next-line max-len
export const getCockpitCookie = (cookies = document.cookie) =>
  getCookie(COCKPIT_COOKIE_NAME, cookies)
